"use strict";

exports.__esModule = true;
exports.Image = void 0;

var _styled = require("@manifest-ui/styled");

const Image = (0, _styled.styled)('img', {
  label: 'Image',
  themeKey: 'image'
})({
  display: 'block',
  height: 'auto',
  minHeight: '100%',
  width: '100%'
});
exports.Image = Image;